import React, { useEffect, useState } from "react";

import styled from "styled-components";

import HtmlHead from "components/atoms/HtmlHead";
import SelectBox from "components/atoms/SelectBox";
import Alert from "components/atoms/alert/Alert";
import StyledText from "components/atoms/text/StyledText";

import BodyWithBreadcrumb from "components/molecules/BodyWithBreadcrumb";
import Breadcrumb from "components/molecules/Breadcrumb";
import LoginUserLayout from "components/templates/LoginUserLayout";

import { useSelectBoxOptions } from "hooks/queries/useOptions";
import { useUser } from "hooks/queries/useUser";

import { apiUrl } from "utils/urls";

import axios from "axios";

const ContentsWrap = styled.div`
    padding: 40px 0 160px 0;
    width: 100%;
    max-width: 1080px;
    max-height: 100%;
`;

const Section = styled.div`
    &:not(:first-of-type) {
        margin-top: 20px;
    }
`;

const SectionTitle = styled(StyledText).attrs({
    withBarType: true,
    fontSize: "regular",
    fontWeight: "bold",
})``;

const SectionDesc = styled(StyledText).attrs({
    fontSize: "small",
    color: "var(--color-SubBlack)",
})`
    padding: 10px;
`;

const SectionContents = styled.div`
    padding: 20px 10px;
`;

const PageTitle = styled(StyledText).attrs({
    fontSize: "large",
    fontWeight: "bold",
})``;

function SettingsPage() {
    const [user, setUser] = useState({});
    const [options, setOptions] = useState({
        env_service_language: [],
        env_ai_language: [],
        env_ai_model: [],
        env_citation_style: [],
    });

    const userQuery = useUser();
    const optionsQuery = useSelectBoxOptions();

    useEffect(() => {
        if (userQuery.data) {
            setUser(userQuery.data);
        }
        if (optionsQuery.data) {
            setOptions(optionsQuery.data);
        }
    }, [userQuery.data, optionsQuery.data]);

    const changeEnvSettingsApi = (changed_settings) => {
        setUser({
            ...user,
            ...changed_settings,
        });
        axios
            .post(apiUrl("changeEnvSettings"), changed_settings)
            .catch((e) => {
                if (e.response.status === 400) {
                    Alert("warn", "에러", e.response.data.error);
                } else {
                    Alert("warn", "에러", "서버에 오류가 발생하였습니다.");
                }
            })
            .finally(() => {
                userQuery.refetch();
            });
    };

    return (
        <LoginUserLayout>
            <HtmlHead title={"환경 설정"} />
            <Breadcrumb>
                <PageTitle>Settings</PageTitle>
            </Breadcrumb>
            <BodyWithBreadcrumb>
                <ContentsWrap>
                    <Section>
                        <SectionTitle>서비스 언어</SectionTitle>
                        <SectionDesc>메뉴, 설명에 사용되는 기본 언어입니다.</SectionDesc>
                        <SectionContents>
                            <SelectBox
                                width="160px"
                                placeholder="서비스 언어 설정"
                                items={options.env_service_language}
                                value={user.env_service_language}
                                onChange={(e) => changeEnvSettingsApi({ env_service_language: e })}
                            />
                        </SectionContents>
                    </Section>

                    <Section>
                        <SectionTitle>AI 응답 언어</SectionTitle>
                        <SectionDesc>AI가 응답을 작성할 때 사용하는 기본 언어입니다.</SectionDesc>
                        <SectionContents>
                            <SelectBox
                                width="160px"
                                height="32px"
                                placeholder="AI 언어 설정"
                                items={options.env_ai_language}
                                value={user.env_ai_language}
                                onChange={(e) => changeEnvSettingsApi({ env_ai_language: e })}
                            />
                        </SectionContents>
                    </Section>

                    <Section>
                        <SectionTitle>AI 생성 모델</SectionTitle>
                        <SectionDesc>AI가 응답을 작성할 때 사용하는 기본 모델입니다.</SectionDesc>
                        <SectionContents>
                            <SelectBox
                                width="160px"
                                height="32px"
                                placeholder="AI모델"
                                items={options.env_ai_model}
                                value={user.env_ai_model}
                                onChange={(e) => changeEnvSettingsApi({ env_ai_model: e })}
                            />
                        </SectionContents>
                    </Section>

                    <Section>
                        <SectionTitle>인용 스타일</SectionTitle>
                        <SectionDesc>참고문헌 표기법을 변경할 수 있습니다.</SectionDesc>
                        <SectionContents>
                            <SelectBox
                                width="160px"
                                height="32px"
                                placeholder="인용 스타일"
                                items={options.env_citation_style}
                                value={user.env_citation_style}
                                onChange={(e) => changeEnvSettingsApi({ env_citation_style: e })}
                            />
                        </SectionContents>
                    </Section>
                </ContentsWrap>
            </BodyWithBreadcrumb>
        </LoginUserLayout>
    );
}

export default SettingsPage;
